<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("bookingsource", 1) }}
      </div>
      <router-link class="btn-blue" to="booking-sources"
        >{{ $tc("bookingsource", 1) }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in BookingSources"
          :key="index"
          v-if="item.fieldname !== 'bs_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'bs_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p v-if="errors.has(item.fieldname)" class="error_message">
              {{ errors.first(`${item.fieldname}`) }}
            </p>
          </div>
          <div
            v-if="item.fieldname === 'bs_is_active'"
            class="d-flex align-items-center"
          >
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="item.fieldvalue"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button class="btn-black" @click.prevent.stop="onResetForm()">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="booking-sources"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import BookingSources from "@/helper/formJSONMaster/BookingSources";

export default {
  data() {
    return {
      btenable: false,
      BookingSources: BookingSources.ms_booking_sources,
      // v-validate="'required|email'"
      submitted: false,
      Methods: BookingSources.Methods,
    };
  },
  mounted() {
    console.log("Booking Sources :", BookingSources);
    this.onResetForm();
  },
  methods: {
    onFocusHandler: function () {
      this.submitted = false;
    },
    onResetForm: function () {
      this.BookingSources.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function (redirect) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody(
            "POST",
            this.BookingSources,
            this.Methods
          );
          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/booking-sources",
                  });
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
          // this.submitted = true;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BookingSourceComponents/addBookingSource.vue